export default {
  SET_LIST: (state, { list, count, has_next, next_page, offset }) => {
    state.list = list;
    state.count = count;
    state.has_next = has_next;
    state.next_page = next_page;
    state.offset = offset;
    // Derive the page size from the response so pagination stays correct
    // even if the backend page size changes.
    if (has_next && next_page > offset) state.page_size = next_page - offset;
  },
  SET_SELECTED: (state, { entry }) => (state.selected = entry),
  SET_SEARCH: (state, { search }) => (state.search = search),
  SET_VOICE_FILTER: (state, { voice }) => (state.voice_filter = voice),
  SET_LOADING: (state, { value }) => (state.is_loading = value),
  SET_VOICES: (state, { voices }) => (state.voices = voices),
};
